'use strict';

module.exports = {
  twoWay: true,
  bind: function bind(el, binding, vnode) {

    el.addEventListener('keydown', function (e) {
      vnode.context[binding.value] = e.target.value;
    });
  },

  update: function update(el, binding, vnode, oldVnode) {}
};


// WEBPACK FOOTER //
// ./src/components/vuetable-2-kernel/compiled/directives/input.js